import { getConfiguration } from "@chr/common-web-ui-configuration";
import { getAxiosInstance } from "@chr/online-shared-microsite-core";
import { CalculateRouteRequest, CalculateRouteResponse } from "@/common/components/tracking-map/MapTypes";

export const calculateRoute = async (request: CalculateRouteRequest[]) => {
  const axios = await getAxiosInstance();
  const baseUrl = (await getConfiguration<AppConfig>()).gatewayApiUri;
  const url = `${baseUrl}/routes/calculate`;
  const data = JSON.stringify(request
  );
  const headers = {
    'Content-Type': 'application/json'
  };

  const response = await axios.post<CalculateRouteResponse>(url, data, { headers });

  return response.data;
};